import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { AlertCircle, Loader2, Lock } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/SiteContext";
import { Logo } from "@/components/site/Brand";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!email || !password) { setErr("Enter your email and password."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      nav("/admin");
    } catch (x) {
      setErr(apiError(x).message);
    } finally { setBusy(false); }
  };

  return (
    <main id="main" className="on-dark flex min-h-screen items-center justify-center bg-horizon px-5 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl md:p-10">
        <div className="flex flex-col items-center text-center">
          <Logo size={150} testid="login-logo" />
          <h1 className="mt-5 text-2xl md:text-3xl">IRID staff sign in</h1>
        </div>
        <form onSubmit={submit} noValidate className="mt-8 space-y-5">
          {err && <p role="alert" className="flex items-center gap-2 rounded-lg bg-irid-error/5 p-3 text-sm font-semibold text-irid-error" data-testid="login-error"><AlertCircle aria-hidden="true" className="h-4 w-4" />{err}</p>}
          <div><label htmlFor="login-email" className="field-label">Email address</label>
            <input id="login-email" type="email" autoComplete="username" className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" /></div>
          <div><label htmlFor="login-password" className="field-label">Password</label>
            <input id="login-password" type="password" autoComplete="current-password" className="field-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" /></div>
          <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="login-submit">
            {busy ? <Loader2 aria-hidden="true" className="h-4 w-4 animate-spin" /> : <Lock aria-hidden="true" className="h-4 w-4" />}Sign in
          </button>
        </form>
        <Link to="/" className="mt-6 block text-center text-sm irid-link" data-testid="login-back-home">Back to irid.org</Link>
      </div>
    </main>
  );
}
